export default __webpack_public_path__ + "static/no-smoking-63d8c9b8365a1a5e2e887eb86153fb8e.png";